import * as Radix from "@radix-ui/themes";
import { Vivid } from "@vendrinc/frontend-ts";
import * as React from "react";
import styles from "./SaasHeader.module.css";
import { MobileMenuContext } from "~/contexts/mobileMenuContext";
import { ReactRouterStubsContext } from "~/contexts/reactRouterStubsContext";
import * as Analytics from "~/hooks/useAnalytics";
import { usePrefab } from "~/hooks/usePrefab";
import * as paths from "~/paths";

export const SaasHeader = () => {
  const { isMobileMenuOpen } = React.useContext(MobileMenuContext);

  const { isEnabled } = usePrefab();
  const isBuyerPortalEnabled = isEnabled("buyer-portal");

  if (isMobileMenuOpen) {
    return null;
  }

  return (
    <Radix.Flex direction="column" gap="0">
      <ChromeExtensionBanner />
      {isBuyerPortalEnabled && <BuyerPortalBanner />}
    </Radix.Flex>
  );
};

const ChromeExtensionBanner = () => {
  const stubs = React.useContext(ReactRouterStubsContext);
  const { trackLink } = Analytics.useAnalytics();

  return (
    <Radix.Flex
      direction="row"
      justify="center"
      align="center"
      className={styles.chromeExtensionBanner}
    >
      <Vivid.Heading node="h3" className={styles.chromeExtensionBannerText}>
        Want instant access to real pricing data for 20k software products?
      </Vivid.Heading>
      <stubs.Link
        onClick={() => {
          trackLink({
            element_text: "Get Free Chrome Extension",
            element_location: "SaaS Header - Chrome Extension",
          });
        }}
        to="https://chromewebstore.google.com/detail/vendr/kghlccelgdbjoadlfnoajfeljdcefnmi"
        prefetch="intent"
        reloadDocument={true}
      >
        <Vivid.Button
          size="compact"
          buttonStyle="secondary"
          className={styles.chromeExtensionBannerButton}
        >
          Get Free Chrome Extension
        </Vivid.Button>
      </stubs.Link>
    </Radix.Flex>
  );
};

const BuyerPortalBanner = () => {
  const stubs = React.useContext(ReactRouterStubsContext);
  const { trackLink } = Analytics.useAnalytics();

  return (
    <Radix.Flex
      direction="row"
      justify="center"
      align="center"
      className={styles.buyerPortalBanner}
    >
      <Vivid.Heading node="h3" className={styles.buyerPortalBannerText}>
        Pricing insights for the top software products. Know the price before
        you buy.
      </Vivid.Heading>
      <stubs.Link
        onClick={() => {
          trackLink({
            element_text: "Get Free Access",
            element_location: "SaaS Header - Buyer Portal",
          });
        }}
        to={paths.buyers.index()}
        prefetch="intent"
        reloadDocument={true}
      >
        <Vivid.Button
          size="compact"
          buttonStyle="secondary"
          className={styles.buyerPortalBannerButton}
        >
          Get Free Access
        </Vivid.Button>
      </stubs.Link>
    </Radix.Flex>
  );
};
